import { FC, ReactNode } from 'react';
import { Card, CardContent, Typography } from '@mui/material';

interface Props {
  title?: string;
  children?: ReactNode;
  marginTop?: boolean;
}

export const LaunchpadCard: FC<Props> = ({ title, children }) => {
  return (
    <Card
      sx={{
        marginTop: '24px',
      }}
    >
      <CardContent>
        {title && (
          <Typography gutterBottom variant="h6">
            {title}
          </Typography>
        )}
        {children}
      </CardContent>
    </Card>
  );
};
